import { yup } from "@swa-ui/object";

let schemas;

export function getMktgDataSchemas() {
  if (!schemas) {
    schemas = {
      vacationsManageMyBooking: mktgVacationsManageMyBookingSchema(),
    };
  }

  return schemas;
}

function mktgVacationsManageMyBookingSchema() {
  return yup.object().shape({
    vacationbannerdisplayed: yup.string().optional(),
  });
}
